import React from 'react'
import { PAGE_SIZE } from '../constants'

/**
 * Displays the range of Kendra Search results being shown on the current page
 * and the total number of results.
 *
 * @see https://github.com/aws-samples/aws-kendra-transcribe-media-search/blob/main/finderapp/src/search/resultsPanel/ResultPanel.tsx
 * @param {Object} props - The component props
 * @param {boolean} props.dataReady - Flag indicating if the data is ready
 * @param {Object} props.results - The results object containing the total number of results and result items
 * @param {number} props.results.TotalNumberOfResults - The total number of results
 * @param {Array} props.results.ResultItems - The array of result items
 * @param {number} props.currentPageNumber - The current page number
 * @returns {JSX.Element} The JSX element displaying the results range and total number of results
 */
const PageIndex = ({ dataReady, results, currentPageNumber }) => {
  // Ensure spacing is always correct
  if (
    !dataReady ||
    !results?.TotalNumberOfResults ||
    results.TotalNumberOfResults <= 0
  ) {
    return <div>&nbsp;</div>;
  }

  const pageStart = (currentPageNumber - 1) * PAGE_SIZE + 1;
  const pageEnd = pageStart + (results.ResultItems?.length - 1);

  const PRECISION = 3;
  let resultsLength = `${results.TotalNumberOfResults}`;
  if (resultsLength.length > PRECISION) {
    resultsLength = resultsLength.substring(0, PRECISION) + '0'.repeat(resultsLength.length - PRECISION);
    resultsLength = parseInt(resultsLength).toLocaleString();
  }

  return (
    <div>
      {resultsLength.length > PRECISION ? (
        <span>
          &nbsp;
          {pageStart}-{pageEnd} of about {resultsLength}
        </span>
      ) : (
        <span>
          {pageStart}-{pageEnd} of {resultsLength} results
        </span>
      )}
    </div>
  );
};

export default PageIndex;